
/**
 * Global application constants.
 */
export const WAITLIST_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbz2gg4fh32c9UhbWg-QWV3ccMG1uyqoEAl_ONp9rJPXzjfq9KMN3Bs1bIu5qvkG0iNWWw/exec';
